/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric, Tabs, TabItem, Button, Loader } from 'ypf-pas-general-ui-components';
import { BsBoxArrowInUpRight, BsCardText } from 'react-icons/bs';
import { AiOutlineLeft, AiOutlineRight, AiFillInfoCircle } from 'react-icons/ai';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import {
  getMonthlySummary,
  getMonthlySummaryHeader,
  getTotalMonthlySummary,
  getTotalSummary
} from '../../../services/workReport';
import { getDetailsHeader } from '../../../services/serviceRequest';
import { getDetailsMonthlyHeader } from '../../../services/monthlyServiceRequest';
import TotalLineTable from '../TotalLineModal/TotalLineTable/TotalLineTable';
import TotalLineSummary from '../TotalLineModal/TotalLineSummary/TotalLineSummary';
import TotalLineOverviewTable from '../TotalLineModal/TotalLineOverviewTable/TotalLineOverviewTable';
import { capitalize, formatDateToSpanish } from '../../../utils/formatUtils';
import useToast from '../../../hooks/useToast';
import MonthlyCalendar from '../../Calendar/MonthlyCalendar/MonthlyCalendar';
import { checkRol } from '../../../security';
import { aprobador } from '../../../security/constantsRols';
import { assignmentTypeEnum } from '../../../utils/dataStatus';
import '../../WellForm/WellForm.scss';
import './MonthlySummaryModal.scss';
import { getPositionComment } from '../../../services/adminContracts';
import { AttachedFilesPermissions } from '../../MonthlyServiceRequest/RequestDetailTypes';
import FilesDetailServiceRequestApprover from '../../ApprovalPending/ViewApprovalPendingContainer/Files/FilesDetailServiceRequestApprover';
import { FilesSdsPtContext } from '../../../context/FilesSdsPtContext';

const actions = {
  leftButton: 'leftButton',
  rightButton: 'rightButton'
};

const enumColors = {
  green: '#FFFFFF,#219E66',
  blue: '#FFFFFF,#159AD8',
  red: '#FFFFFF,#FF6666',
  greenLight: '#219E66,#FFFFFF'
};

const MonthlySummaryModal = (props) => {
  const {
    show,
    onHide,
    line,
    date: startDate,
    idWork,
    tipoAsignacion,
    monthly,
    filesPermissions,
    idLocation
  } = props;
  const { setIsMonthly } = useContext(FilesSdsPtContext);

  const { activeEndServiceModal } = useWorkReportModals();
  const [lineInfo, setLineInfo] = useState(null);
  const [monthlySummary, setMonthlySummary] = useState(null);
  const [overview, setOverview] = useState(null);
  const [lastAction, setLastAction] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [applicationSummary, setAppSum] = useState(false);
  const [canEndService, setCanEndService] = useState(false);
  const [serviceRequestCurrency, setServiceRequestCurrency] = useState('');
  const [contractNumber, setContractNumber] = useState('');
  const [numberPosition, setNumberPosition] = useState('');
  const [positionComment, setPositionComment] = useState(null);
  const [detailsHeader, setdetailsHeader] = useState(null);

  const [date, setDate] = useState(startDate);
  const { year, month } = formatDateToSpanish(date);
  const history = useHistory();
  const { setNewToast } = useToast();

  const showEndServiceModal = (info, asignacion) => {
    activeEndServiceModal(info, asignacion);
  };

  const previousMonth = () => {
    const newDate = new Date(date);
    const previousDate = new Date(newDate.getFullYear(), newDate.getUTCMonth() - 1, 1);

    setDate(previousDate.toISOString());
    setLastAction(actions.leftButton);
  };
  const nextMonth = () => {
    const newDate = new Date(date);
    const nextDate = new Date(newDate.getFullYear(), newDate.getUTCMonth() + 1, 1);

    setDate(nextDate.toISOString());
    setLastAction(actions.rightButton);
  };

  const fetchHeaderData = async (lineValue, tipoAsignacionValue) => {
    const header = await getMonthlySummaryHeader(lineValue, tipoAsignacionValue);

    setLineInfo(header);
    setIsMonthly(tipoAsignacionValue === assignmentTypeEnum.Mensualizada);

    const details =
      tipoAsignacionValue !== assignmentTypeEnum.Mensualizada
        ? await getDetailsHeader(header.idSolicitudServicio)
        : await getDetailsMonthlyHeader(header.idSolicitudServicio);

    setdetailsHeader(details);
    setCanEndService(details.botonFinalizarServicio);
    setServiceRequestCurrency(details.moneda);
    setContractNumber(details.numeroContrato);
    setNumberPosition(header.nroPosicion);
  };

  const getVariant = (color) => {
    switch (color) {
      case enumColors.green:
        return 'green';
      case enumColors.blue:
        return 'blue';
      case enumColors.red:
        return 'red';
      case enumColors.greenLight:
        return 'green-light';
      default:
        return '';
    }
  };

  const adaptSummary = (summary) =>
    summary.parteTrabajoDiarios.length
      ? summary.parteTrabajoDiarios.map((pt) => ({
          ...pt,
          variant: getVariant(pt.color)
        }))
      : [];

  const fetchOverviewData = async (lineValue) =>
    tipoAsignacion !== assignmentTypeEnum.Mensualizada
      ? getTotalSummary(idWork)
      : getTotalMonthlySummary(lineValue);

  const fetchSummaryData = async (lineValue, dateValue, monthlyValue) => {
    const summary = await getMonthlySummary(lineValue, dateValue, monthlyValue);
    const adapterSummary = adaptSummary(summary);

    setMonthlySummary({
      ...summary,
      parteTrabajoDiarios: adapterSummary
    });
    if (idWork || idLocation) {
      // lineValue is no longer used because that value is only a line id;
      // here we want all lines, hence using idLocation
      const overData = await fetchOverviewData(idLocation);

      setOverview(overData);
    }
  };

  const fetchData = async () => {
    setDisableButton(true);
    setLoading(true);
    try {
      if (line) {
        await fetchHeaderData(line, tipoAsignacion);
      }

      if (line && date) {
        await fetchSummaryData(line, date, monthly);
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setMonthlySummary(null);
    }
    setDisableButton(false);
    setLoading(false);
  };

  const fetchPositionComment = async (nroContract, nroPosition) => {
    try {
      const response = await getPositionComment(nroContract, nroPosition);

      if (response.data?.tieneComentario) {
        setPositionComment(response.data.comentario);
      }
    } catch (err) {
      setPositionComment(null);
    }
  };

  useEffect(() => {
    if (!show) {
      setLineInfo(null);
      setMonthlySummary(null);
      setOverview(null);
      setAppSum(false);
      setCanEndService(false);
      setContractNumber(null);
      setNumberPosition(null);
      setPositionComment(null);
    }
    if (show) {
      fetchData();
    }
  }, [line, date, show]);

  useEffect(() => {
    if (startDate) {
      setDate(startDate);
    }
  }, [startDate]);

  useEffect(() => {
    if (
      show &&
      contractNumber !== '' &&
      numberPosition !== '' &&
      contractNumber !== null &&
      numberPosition !== null
    ) {
      fetchPositionComment(contractNumber, numberPosition);
    }
  }, [contractNumber, numberPosition]);

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onHide}
      primaryAction={onHide}
      primaryActionLabel="Salir"
      primaryActionVariant="primary"
      secondaryAction={
        checkRol(aprobador) &&
        canEndService &&
        (() => showEndServiceModal(lineInfo, tipoAsignacion))
      }
      secondaryActionLabel={checkRol(aprobador) && canEndService && 'Finalizar Servicio'}
      secondaryActionVariant="outline-danger"
      show={show}
      size="xl"
      title="Resumen posición y línea"
    >
      <>
        <div className="monthly-summary-modal">
          <p className="text-center modal-info">
            {applicationSummary && (
              <>
                Información de la solicitud en base al periodo vigente con sus posiciones y lineas
                <br />
              </>
            )}
            {lineInfo && !applicationSummary && (
              <>
                {!!positionComment && (
                  <OverlayTrigger
                    delay={{
                      show: 250,
                      hide: 400
                    }}
                    overlay={<Tooltip id="button-tooltip">{positionComment}</Tooltip>}
                    placement="bottom"
                  >
                    <span>
                      <AiFillInfoCircle className="text-primary m-2" />
                    </span>
                  </OverlayTrigger>
                )}
                {lineInfo?.detalleDeLinea}
                <br />
              </>
            )}
          </p>
          <div className="object-pills ubication-info mb-2 mt-1">
            <div className="pills">
              <h6 className="pill light">{lineInfo?.ubicacion}</h6>
            </div>
          </div>
          <div className="sds-info">
            <p className="sds-number">
              {lineInfo?.numeroSolicitudServicio}
              {checkRol(aprobador) && (
                <Button
                  icon={BsBoxArrowInUpRight}
                  onClick={() => {
                    onHide();
                    if (tipoAsignacion !== assignmentTypeEnum.Mensualizada) {
                      history.push(`/detail/${lineInfo?.idSolicitudServicio}`);
                    } else {
                      history.push(`/detailmonthly/${lineInfo?.idSolicitudServicio}`);
                    }
                  }}
                  type="button"
                  variant="light-gray"
                  widthButton="30px"
                />
              )}
            </p>
            <span className="divider">|</span>
            <p>{lineInfo?.servicioAsociado}</p>
            <span className="divider">|</span>
            <p>{lineInfo?.proveedor}</p>
          </div>
          <div className="month-slider-container">
            {!(lastAction === actions.leftButton && !monthlySummary?.parteTrabajoDiarios.length) ? (
              <Button
                colorIcon="secondary"
                disabled={disableButton || monthly}
                icon={AiOutlineLeft}
                onClick={previousMonth}
                type="button"
                widthButton="30px"
              />
            ) : (
              <span />
            )}
            <div className="month-container">
              {capitalize(month)} de {year}
            </div>
            {!(
              lastAction === actions.rightButton && !monthlySummary?.parteTrabajoDiarios.length
            ) && (
              <Button
                colorIcon="secondary"
                disabled={disableButton || monthly}
                icon={AiOutlineRight}
                onClick={nextMonth}
                type="button"
                widthButton="30px"
              />
            )}
          </div>

          {applicationSummary && (
            <div className="object-pills ubication-info">
              <BsCardText className="summary-card-icon total-txt" />
              <span className="total-txt">Total de Solicitud:</span>
              <span className="total-txt total-txt-number"> ${overview?.totalDeLaSolicitud}</span>
            </div>
          )}

          <div className="monthly-summary-view">
            <Tabs defaultActiveKey="calendar">
              <TabItem
                eventKey="calendar"
                onClickTab={() => setAppSum(false)}
                title="VISTA CALENDARIO"
              >
                <div
                  className="monthly-summary-tab"
                  style={{
                    gridTemplateColumns: '60% 40%'
                  }}
                >
                  <MonthlyCalendar
                    arrayDate={monthlySummary?.parteTrabajoDiarios}
                    date={date}
                    isSummaryModal
                    showActions={false}
                    showHeader={false}
                  />
                  <TotalLineSummary className="monthly-summary-cards" lineInfo={monthlySummary} />
                </div>
              </TabItem>
              <TabItem eventKey="table" onClickTab={() => setAppSum(false)} title="VISTA TABLA">
                <div className="monthly-summary-tab-table">
                  <TotalLineSummary
                    className="monthly-summary-table-cards"
                    lineInfo={monthlySummary}
                  />
                  <TotalLineTable
                    dailyWorkReports={monthlySummary?.parteTrabajoDiarios}
                    serviceRequestCurrency={serviceRequestCurrency}
                  />
                </div>
              </TabItem>
              <TabItem
                eventKey="overview"
                onClickTab={() => setAppSum(true)}
                title="RESUMEN DE LA SOLICITUD"
              >
                <div className="monthly-summary-tab">
                  <TotalLineOverviewTable
                    dailyWorkReports={overview?.resumenMensualPorLineaSolicitud}
                    serviceRequestCurrency={serviceRequestCurrency}
                    tipoAsignacion={tipoAsignacion}
                  />
                </div>
              </TabItem>
              <TabItem eventKey="archivos" title="ARCHIVOS">
                <FilesDetailServiceRequestApprover
                  detailsHeader={detailsHeader}
                  filesPermissions={filesPermissions}
                />
              </TabItem>
            </Tabs>
          </div>
          <hr />
        </div>
        <Loader show={loading} text="CARGANDO" />
      </>
    </ModalGeneric>
  );
};

export default MonthlySummaryModal;

MonthlySummaryModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  line: PropTypes.number,
  date: PropTypes.string,
  idWork: PropTypes.number,
  tipoAsignacion: PropTypes.number,
  monthly: PropTypes.bool,
  filesPermissions: AttachedFilesPermissions,
  idLocation: PropTypes.number
};

MonthlySummaryModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  line: null,
  date: '',
  idWork: null,
  tipoAsignacion: null,
  filesPermissions: {
    visualize: false,
    write: false
  },
  monthly: false,
  idLocation: null
};
